export default __webpack_public_path__ + "static/media/Group 626075.10de9702.svg";